import { FC } from 'react'
import { PageContainer } from '../components/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import dynamic from 'next/dynamic'

/* istanbul ignore next */
const DomainsContainer = dynamic<Record<string, unknown>>(() =>
  import('@app/code/src/containers/domains/Domains').then(mod => mod.DomainsContainer)
)

const Domains: FC = () => {
  useRedirectOnAuthChanges(true)

  return (
    <PageContainer hideContentIfLoggedOut page={Routes.DOMAINS}>
      <DomainsContainer />
    </PageContainer>
  )
}

export default Domains
